export const formatSalaryComponents = (obj: {
  [key: string]: string;
}): { [key: string]: string } => {
  let result: { [key: string]: string } = {};

  Object.keys(obj).forEach((key) => {
    const value = obj[key];

    // filter out falsy and non-object values
    if (value && typeof obj[key] !== "object") {
      // for example: Ammattitutkintolisä (suorituspalkkatyö): "12"
      result[key] = obj[key];
    }
  });

  return result;
};

/**
 * Formats per-zone salary components (e.g. PKS) from form values, the same
 * way `formatSalaryComponents` does for the non-zoned components.
 *
 * Returns `undefined` when there is nothing to save, so callers can decide
 * whether to include a zoned salary at all (e.g. `...(result && { zonedSalary: result })`).
 */
export const buildZonedSalaryComponents = (
  zonedComponents: Record<string, Record<string, string>> | undefined,
): Record<string, Record<string, string>> | undefined => {
  if (!zonedComponents) return undefined;

  const hasValues = Object.values(zonedComponents).some((components) =>
    Object.values(components).some(
      (value) => typeof value === "string" && value.trim() !== "",
    ),
  );
  if (!hasValues) return undefined;

  return Object.fromEntries(
    Object.entries(zonedComponents).map(([zone, components]) => [
      zone,
      formatSalaryComponents(components),
    ]),
  );
};
